import {
  createUnifiedTheme,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';

export const exoDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: {
      main: '#7df3e1',
    },
    secondary: {
      main: '#6366f1',
    },
    navigation: {
      background: '#0f0f1a',
      indicator: '#7df3e1',
      color: '#b5b5b5',
      selectedColor: '#ffffff',
      navItem: {
        hoverBackground: '#1a1a2e',
      },
    },
    background: {
      default: '#121212',
      paper: '#1e1e2f',
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({
      colors: ['#7df3e1', '#6366f1'],
      shape: shapes.wave,
    }),
    tool: genPageTheme({
      colors: ['#6366f1', '#7df3e1'],
      shape: shapes.round,
    }),
    documentation: genPageTheme({
      colors: ['#4dd0e1', '#6366f1'],
      shape: shapes.wave2,
    }),
    service: genPageTheme({
      colors: ['#7df3e1', '#4dd0e1'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#6366f1', '#7df3e1'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#4dd0e1', '#7df3e1'],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: ['#7df3e1', '#6366f1'],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: ['#7df3e1', '#6366f1'],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: ['#6366f1', '#4dd0e1'],
      shape: shapes.wave2,
    }),
  },
});
